import styled from "styled-components"

import { CardsRow, Section, SectionTitle } from "./shared"
import { ShareLinkCard } from "./ShareLinkCard"

const PageStack = styled.main`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const ReferralAgentDashboard = () => {
  return (
    <PageStack>
      <Section>
        <SectionTitle>Your referral link</SectionTitle>
        <CardsRow>
          <ShareLinkCard />
        </CardsRow>
      </Section>
    </PageStack>
  )
}
